var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.25,
    d: "M2.324 5c0-.649.526-1.175 1.175-1.175H16.5c.649 0 1.175.526 1.175 1.175v11.3c0 .649-.526 1.175-1.175 1.175h-13A1.175 1.175 0 0 1 2.323 16.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.625,
    height: 3.542,
    x: 6.146,
    y: 2.013,
    stroke: "#fff",
    strokeWidth: 0.625,
    rx: 0.313
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.625,
    height: 3.542,
    x: 13.229,
    y: 2.013,
    stroke: "#fff",
    strokeWidth: 0.625,
    rx: 0.313
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "m7 10.3 2.36 2.832a.2.2 0 0 0 .295.013L14 8.8"
  })));
};
export default SvgCalendar;